export default __webpack_public_path__ + "static/media/Standard07.32a8c8e8.png";